import { darken } from "@mui/material";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_BLACK_LIGHTER, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import React from "react";

export default function PotwIntroBanner() {
  const title = "Plays of the Week";
  const descriptionHeader = "Vote for the best highlights or relive the top plays.";
  const colorDarken = darken(COLOR_BLACK_LIGHTER, 0.5);

  return (
    <>
      <div
        style={{
          color: COLOR_WHITE,
          background: `linear-gradient(0deg, ${COLOR_BLACK_LIGHTER}, ${colorDarken})`,
          display: "flex",
          flexFlow: "row wrap",
          alignItems: "center",
          padding: SPACING,
          gap: 40,
        }}
      >
        <div
          style={{
            display: "flex",
            flexFlow: "column nowrap",
            gap: 10,
            margin: "0 auto",
            maxWidth: MAX_CONTENT_WIDTH,
            width: `calc(100vw - ${SPACING} * 2)`,
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: `min(44px, 10vw)`,
              textTransform: "uppercase",
              fontFamily: FONT_FAMILY_GRAPHIK,
              fontWeight: 800,
            }}
          >
            {title}
          </h1>
          <div
            style={{
              fontFamily: FONT_FAMILY_GRAPHIK,
              fontSize: 12,
              opacity: 0.6,
            }}
          >
            {descriptionHeader}
          </div>
        </div>
      </div>
    </>
  );
}
